export default function() {
  return {
    user_id: null,
    vendor_project_id: null,
    customer: null,
    type: null,
    stock: null,
    attachments: [],
    journal: null,
    remarks: null,
    files: [null],
  }
}